module.exports = __webpack_public_path__ + "static/media/sku715003059.876da1b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/sku715003059.png
// module id = 597
// module chunks = 0